import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { InputSelectControlField } from '@sequencehq/core-components'
import React from 'react'

export const UsageEventPropertySelect = ({
  filterNames,
  ...fieldProps
}: Omit<React.ComponentProps<typeof InputSelectControlField>, 'options'> & {
  filterNames: string[]
}) => {
  const usageEventPropertiesQuery = useQuery(
    dashboard20240730Client.getUniqueUsageEventProperties
  )
  const eventProperties =
    usageEventPropertiesQuery.data?.items
      .filter(item => !filterNames.includes(item))
      .map(v => ({ label: v, value: v })) ?? []

  return (
    <InputSelectControlField
      label="Event property"
      placeholder="Select event property"
      options={eventProperties.filter(option => option.value)}
      {...fieldProps}
    />
  )
}
